<template>
  <div class="">
    <cReviewHotel
      :hotelObj="hotelObj"
      :isToggleOption="true"
      :isEditOption="true"
      :isShowLeftPart="true"
      :isHideDetails="true"
    />
  <div>
    <cSurchargeSetup      @onSurchargeFormSave="navToHotelInfo"
        @onSurchargeFormCancel="navToHotelInfo">

    </cSurchargeSetup>
  </div>

  </div>
</template>
<script>

import cReviewHotel from "../../../../../components/hms/cReviewHotel";
import {
  COMPONENT_NAME,
  DATE_TIME_FORMAT,
  PATHNAME,
  SURCHARGE_TYPES,
  DEFAULT_DROPDOWN_STATUS,
} from "../../../../../util/constants";
import Logger from "../../../../../services/logger";
import multiselect from "vue-multiselect";
import BaseConfiguration from "../../../../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneDeep,
  cloneData,
} from "../../../../../util/util";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../../../config/API_DATA";
import apiGetHotelRooms from "../../../../../services/apiGetHotelRooms";
import cTextInputComponent from "../../../../../components/form/cTextInputComponent";
import cAlertModal from "../../../../../components/form/cAlertModal";
import apiGetRatePlan from "../../../../../services/apiGetRatePlan";
import apiCreateSurcharge from "../../../../../services/apiCreateSurcharge";
import apiUpdateSurcharge from "../../../../../services/apiUpdateSurcharge";
import cRoomTypeInfo from "../../../../../components/hms/manage/hotelInfo/cRoomTypeInfo";

import apiUpdateRatePlanStatus from "../../../../../services/apiUpdateRatePlanStatus";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
import datePickerInput from "../../../../../components/datePicker/datePickerInput";
import { VMdDateRangePicker } from "material-vue-date-picker";

import cCurrencyDropDown from "../../../../../components/currency/cCurrencyDropDown.vue";
import { goBack, navigate } from "../../../../../router";
import { addDays } from "../../../../../util/date/dateFunctions";

import cHelpTip from "../../../../../components/cHelpTip.vue";
import cSurchargeSetup from "../../../../../components/hms/manage/hotelInfo/cSurchargeSetup";


export default {
  name: COMPONENT_NAME.SURCHARGE_NEW,

  components: {
    cReviewHotel,
    cSurchargeSetup

  },
  data: () => {
    return {
     
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      SURCHARGE_PRICING: "GET_SURCHARGE_PRICING",
    }),

    ...mapGetters("shmsManage", {
      hotelObj: "GET_SEL_HOTEL",
    }),
    ...mapGetters("sHotelInfo", {
      selSurcharge: "GET_SEL_SURCHARGE",
    }),
  },

  methods: {
    navToHotelInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToHotelInfo");

        goBack();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.SURCHARGE_NEW,
          "error in navToHotelInfo",
          err.toString(),
          "navToHotelInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
 
 },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.SURCHARGE_NEW,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },


};
</script>
<style scoped>
.align-curr {
  margin-top: 22px;
}
</style>
